import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from './useDeleteModal';

interface IDeleteModal {
  openModal: boolean;
  dataToDelete: { id: string | undefined };
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: IDeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={() => onDeleteModalClose()}
        isLoading={isLoading}
        open={openModal}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={() => onDeleteModalClose()}
        title={'Delete Client Type Pricing Rule'}
        message={'Are you sure you want to delete this Client Type Pricing Rule?'}
      />
    </>
  );
};
